import { render, staticRenderFns } from "./OpportunityPreview.vue?vue&type=template&id=20c1defc&scoped=true"
import script from "./OpportunityPreview.vue?vue&type=script&lang=js"
export * from "./OpportunityPreview.vue?vue&type=script&lang=js"
import style0 from "./OpportunityPreview.vue?vue&type=style&index=0&id=20c1defc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1defc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c1defc')) {
      api.createRecord('20c1defc', component.options)
    } else {
      api.reload('20c1defc', component.options)
    }
    module.hot.accept("./OpportunityPreview.vue?vue&type=template&id=20c1defc&scoped=true", function () {
      api.rerender('20c1defc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/OpportunityPreview.vue"
export default component.exports